/**
 * Rules for blocking the chat until Microsoft Project is paired.
 *
 * Kept separate from taskpane.js so the decision is testable on its own — the
 * exemptions below are easy to regress and impossible to notice until someone
 * is locked out of an app that should have opened.
 */

/**
 * Whether this session is subject to the gate at all.
 *
 * A legacy API-key session is exempt: it has no connector installations to
 * list, so gating one would block it permanently with no way to pass. Sessions
 * with Entra disabled are exempt for the same reason — pairing does not exist
 * for them.
 *
 * @param {{authConfig?: object, currentUser?: object, legacyApiKey?: string}} state
 * @returns {boolean}
 */
export function connectorGateApplies({ authConfig, currentUser, legacyApiKey } = {}) {
  return Boolean(authConfig?.entra?.enabled && currentUser && !legacyApiKey);
}

/**
 * Whether the chat should currently be hidden.
 *
 * `installations` is the account's paired-connector list. Pass null/undefined
 * when it could not be fetched: an unknown pairing state stays gated rather
 * than failing open, because a backend that cannot answer this cannot serve
 * chat either.
 *
 * @param {{authConfig?: object, currentUser?: object, legacyApiKey?: string,
 *          installations?: Array|null}} state
 * @returns {boolean}
 */
export function shouldGateChat({
  authConfig,
  currentUser,
  legacyApiKey,
  installations,
} = {}) {
  if (!connectorGateApplies({ authConfig, currentUser, legacyApiKey })) return false;
  if (!Array.isArray(installations)) return true;
  return installations.length === 0;
}
